import confetti from "canvas-confetti";

export function fireConfetti() {
  const defaults = { spread: 60, startVelocity: 35, ticks: 200, zIndex: 9999 };
  const colors = ["#FF4343", "#FFFFFF", "#10B981", "#F59E0B", "#3B82F6"];
  function shoot(originX, particleCount = 60) {
    confetti({ ...defaults, particleCount, origin: { x: originX, y: 0.85 }, colors });
  }
  shoot(0.15, 80);
  setTimeout(() => shoot(0.5, 100), 150);
  setTimeout(() => shoot(0.85, 80), 300);
}

export function fireBigConfetti() {
  fireConfetti();
  setTimeout(fireConfetti, 800);
}
